import { booleanAttribute, ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatCard, MatCardContent } from '@angular/material/card';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { type AbstractControl, ReactiveFormsModule } from '@angular/forms';
import { AutocompleteComponent, StringSlideToggleComponent } from '@pct-ng/form';
import { TranslocoDirective } from '@jsverse/transloco';
import { MatDivider } from '@angular/material/divider';
import type { AbstractDtoService } from '@pct-ng/core/dto';
import { ProgressBarComponent } from '@pct-ng/common/component';
import { AbstractFormFragmentComponent } from './abstract-form-fragment.component';

@Component({
  selector: 'cappus-categories-and-location-form-fragment',
  imports: [
    MatDivider,
    MatCardContent,
    MatCard,
    MatSlideToggle,
    ReactiveFormsModule,
    StringSlideToggleComponent,
    AutocompleteComponent,
    TranslocoDirective,
    ProgressBarComponent,
  ],
  templateUrl: './categories-and-location-form-fragment.component.html',
  host: {
    class: 'block w-full',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CategoriesAndLocationFormFragmentComponent<
  FORM extends { [key: string]: AbstractControl<any, any> },
> extends AbstractFormFragmentComponent<FORM> {
  // readonly controlsNames = input.required<{
  //   status: string;
  //   isHighlighted: string;
  //   isSZTE: string;
  //   categoryIds: string;
  // }>();
  // location = AdminLocationDtoService (csomag altalanositas miatt nem tudjuk felirni a tipust, de nincs is ra szukseg itt)
  readonly locationDtoService = input<AbstractDtoService<any, any, any, any, any>>();
  readonly StatusCodes = input.required<readonly string[]>();

  readonly showLocation = input(false, { transform: booleanAttribute });
  readonly showIsUniversity = input(false, { transform: booleanAttribute });
  readonly showIsPublishNotificationEnabled = input(false, { transform: booleanAttribute });
  readonly categoryDtoService = input.required<AbstractDtoService<any, any, any, any, any>>();
  readonly locationIdControlName = input('locationId');
  readonly isUniversityControlName = input('isUniversity');
}
